"use client";
import { NavItem } from "../types";
import { MobileNavbar } from "./MobileNavbar";
import Link from "next/link";
import Image from "next/image";
import { DesktopNavMenu } from "./DesktopNavMenu";

interface DesktopNavbarProps {
	navItems: NavItem[];
	currentPath: string;
	extraNavItems?: NavItem[];
}

export const DesktopNavbar = ({
	navItems,
	currentPath,
	extraNavItems,
}: DesktopNavbarProps) => {
	return (
		<div className="w-full bg-transparent">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					{/* Marca: sello + wordmark */}
					<Link
						href="/"
						className="group flex items-center gap-2.5"
						aria-label="Aranzazu Gutiérrez, ir a la página principal"
					>
						<Image
							src="/assets/brand/aranzazu-seal.svg"
							alt=""
							width={36}
							height={36}
							priority
							unoptimized
							className="w-9 h-9 object-contain"
						/>
						<span className="font-display text-xl text-ink group-hover:text-terracotta transition-colors duration-200 tracking-tight leading-none">
							Aranzazu Gutiérrez
						</span>
					</Link>

					{/* Navigation items - horizontal */}
					<div className="hidden lg:flex lg:items-center lg:gap-1">
						<DesktopNavMenu navItems={navItems} currentPath={currentPath} />
					</div>

					<div className="lg:hidden flex justify-end items-center">
						<MobileNavbar
							currentPath={currentPath}
							navItems={navItems}
							extraNavItems={extraNavItems || []}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
